import { MantineThemeOverride } from '@mantine/core';

export type SpaceTheme = NonNullable<MantineThemeOverride['components']>['Space'];

export const Space: SpaceTheme = {
  // todo: define
};
